import React from "react";
import BusinessOutlinedIcon from "@material-ui/icons/BusinessOutlined";
import factoryImage from "../assets/images/Manufacturer.png";
import ceImage from "../assets/images/CE2797.png";
export const TermsAndCondition = () => {
  return (
    <div>
      <p>
        Uptake Medical’s analysis of the computed tomography scans provided is
        strictly limited in scope and extent to the analysis necessary for
        preparation of the IP3. Accordingly, Uptake Medical assumes no
        responsibility or liability with respect to analyzing or reporting
        additional data or findings in connection with its receipt of such CT
        scans.
      </p>
    </div>
  );
};
export const PrivacyPolicy = () => {
  return (
    <div>
      <p>
        Uptake Medical’s CT upload function uses the Digital Imaging and
        Communications in Medicine (DICOM) standard.
      </p>
      <p>
        Uptake Medical does not collect or store any Protected Health
        Information (PHI). Upon upload of a CT scan, all PHI is deidentified
        from DICOM tags. Please do not include PHI in comments fields or
        communications.
      </p>
    </div>
  );
};
export const Copyright = () => {
  return (
    <div>
      <p>
        {/* IP3 Web Portal, Version:1.0.0. &copy;<span className = "helvetica-font" >2021</span> Uptake Medical Technology Inc. All Rights Reserved. */}
        IP3 Web Portal, Version:1.0.0. &copy; 2021 Uptake Medical Technology Inc. All Rights Reserved.
        InterVapor and IP3 are registered trademarks of Uptake Medical
        Technology Inc.
      </p>
      <p style ={{display:"flex"}}>
        {/* <BusinessOutlinedIcon /> <br /> */}
        <img src={factoryImage} width ={22} height = {18} /> <br />

        <span className="uptakeSpan">
          <p>
            Uptake Medical Technology Inc.
            <br />
          </p>
          <p>
          {/* <span className = "helvetica-font" >125</span> Nicholson Lane */}
          125 Nicholson Lane
            <br />
          </p>
          <p>
            {/* San Jose, CA <span className = "helvetica-font" >95134 </span> */}
            San Jose, CA 95134 
            <br />
          </p>
          <p>
            USA
            <br />
          </p>
          <p>
            <a href="https://www.uptakemedical.com" target="_blank">
              www.uptakemedical.com
            </a>
          </p>
        </span>
      </p>
      <p style={{display:"flex"}}>
        <img src={factoryImage} width ={22} height = {18} /> 
        <span className="uptakeSpan">
          <p>
            Uptake Medical B.V.
            <br />
          </p>
          <p>
            {" "}
            {/* De Tweeling <span className = "helvetica-font" >20-22</span> */}
            De Tweeling 20-22
            <br />
          </p>
          <p>
            {" "}
            {/* <span className = "helvetica-font" >5215MC</span> 's-Hertogenbosch */}
            5215MC 's-Hertogenbosch
            <br />
          </p>
          <p>
            {" "}
            The Netherlands
            <br />
          </p>
          <p>
            {" "}
            <a href="https://www.uptakemedical.com" target="_blank">
              www.uptakemedical.com
            </a>
          </p>
        </span>
        {/* <img src= {ceImage} width ={18.897637795 } height = {18.897637795}/> */}
      </p>
    </div>
  );
};
